export const parseDateParam = (value: string | null): Date | null => {
  if (!value) return null;
  const trimmedValue = value.trim();
  const localDateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmedValue);

  // Parse YYYY-MM-DD as local date to avoid timezone shifts on round-trip.
  if (localDateMatch) {
    const [, yearRaw, monthRaw, dayRaw] = localDateMatch;
    const year = Number(yearRaw);
    const month = Number(monthRaw);
    const day = Number(dayRaw);
    const parsedLocal = new Date(year, month - 1, day);

    const isValidLocalDate =
      !Number.isNaN(parsedLocal.getTime()) &&
      parsedLocal.getFullYear() === year &&
      parsedLocal.getMonth() === month - 1 &&
      parsedLocal.getDate() === day;

    return isValidLocalDate ? parsedLocal : null;
  }

  const parsed = new Date(trimmedValue);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};
